export default [
  {
    path: '*',
    redirect: { name: '404' },
  },
];



// WEBPACK FOOTER //
// ./src/router/routes/common.js